import script from "./MetricUnitInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricUnitInput.vue?vue&type=script&setup=true&lang=js"

import "./MetricUnitInput.vue?vue&type=style&index=0&id=b8cafa9a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8cafa9a"]])

export default __exports__